import {formatIsoDate} from '@/shared/utils/dates'
import {Alert, Flex, Text} from '@chakra-ui/react'
import {isoDateFromTimestamp, type ProtocolOverlap} from '@cypro/engine/utils'
import {useTranslate} from '@tolgee/react'

export function ActiveProtocolOverlapAlert({overlaps}: {overlaps: ProtocolOverlap[]}) {
  const {t} = useTranslate('common')
  if (!overlaps.length) return null

  return (
    <Alert.Root status="warning" borderRadius="md" width="100%" data-e2e="active-protocol-overlap-warning">
      <Alert.Indicator />
      <Alert.Content>
        <Alert.Title>{t('active_protocol_overlap.title', 'Active protocol overlap')}</Alert.Title>
        <Alert.Description>
          {overlaps.map(overlap => (
            <Flex key={overlap.patientProtocolId} wrap="wrap" columnGap="5">
              <OverlapValue label={t('protocol')} value={overlap.protocolName} />
              <OverlapValue
                label={t('protocol.start_date')}
                value={formatIsoDate(isoDateFromTimestamp(overlap.startDate))}
              />
              <OverlapValue
                label={t('active_protocol_overlap.last_planned_treatment', 'Last planned treatment')}
                value={formatIsoDate(overlap.lastPlannedDate)}
              />
            </Flex>
          ))}
        </Alert.Description>
      </Alert.Content>
    </Alert.Root>
  )
}

function OverlapValue({label, value}: {label: string; value: string}) {
  return (
    <Text as="span">
      {label}:{' '}
      <Text as="span" fontWeight="semibold">
        {value}
      </Text>
    </Text>
  )
}
